import React, {lazy, Suspense} from 'react';
import {AppContext} from '../../../AppModule/Context';

import {withWidgetContext} from '../widgetContextProvider';

//Services
import DynamicFormService from '../../../services/restServices/dynamicFormService';
import DynamicInstanceService from '../../../services/restServices/dynamicInstanceService';
import PostMessageService from '../../../services/postMessageService';
import multiWidgetService from '../../../services/multiWidgetService';
import sessionTemplateService from '../../../services/restServices/sessionTemplateService';
import utilsService from '../../../services/utilsService';

//Constants
import VIDABOO_CONSTANTS from '../../../config/consts';

//Component
import ArrowIcon from '../../../assets/svgComponents/Arrow';
import ButtonComponent from '../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import ConsentComponent from './consentComponent';
import InputComponent from '../../common/genericComponents/redesign/inputComponent/inputComponent';
import NotificationComponent from '../../common/genericComponents/notificationComponent';
import PhoneInput from '../../common/genericComponents/phoneNumberInput';
import ShimmerWithEmptyImageComponent from '../../common/genericComponents/redesign/shimmerWithEmptyImageComponent/shimmerWithEmptyImageComponent';
import SuspenseLoader from '../../common/genericComponents/suspenseLoader/suspenseLoader';
import ToolTipComponent from '../../common/genericComponents/toolTipComponent';
import WidgetTitleComponent from './widgetTitleComponent';

import './leadCollectorComponent.css';

const C2cPaymentComponent = lazy(
  () => import('../../paymentRequestComponent/c2cPaymentComponent'),
);

class LeadCollectorComponent extends React.Component {
  constructor(props) {
    super(props);
    this.formTypes = {
      [VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT]:
        VIDABOO_CONSTANTS.DYNAMIC_FORM_TEMPLATE_TYPE.PRE_CHAT,
      [VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL]:
        VIDABOO_CONSTANTS.DYNAMIC_FORM_TEMPLATE_TYPE.PRE_CALL,
      [VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING]:
        VIDABOO_CONSTANTS.DYNAMIC_FORM_TEMPLATE_TYPE.PER_SCHEDULE,
      [VIDABOO_CONSTANTS.WIDGET_APP_TYPES.INFO_COLLECTOR]:
        VIDABOO_CONSTANTS.DYNAMIC_FORM_TEMPLATE_TYPE.CONTACT_FORM,
    };
    this.formValidationRegexPatterns = {
      PHONE_NUMBER: VIDABOO_CONSTANTS.VALIDATION_PATTERNS.PHONE_NUMBER,
      NUMBER: VIDABOO_CONSTANTS.VALIDATION_PATTERNS.NUMBER,
      EMAIL: VIDABOO_CONSTANTS.VALIDATION_PATTERNS.EMAIL,
    };
    this.state = {
      isFormLoading: false,
      isFormFlowRunning: false,
      messageToMentor: {},
      dynamicFormTemplate: {},
      initialFormFieldsContent: null,
      formFields: [],
      showToolTip: {},
      isFormDataValid: false,
      isSubmitBtnClicked: false,
      consentFormField: null,
      isConsentAccepted: false,
      showConsentAnim: false,
      isConsentAcceptedInPast: false,
      paymentFlowBasedSessionDto: null,
      paymentDtoDFInstanceId: null,
    };
  }
  componentDidMount = () => {
    this.initializeMessageToMentor();
    this.updateIsConsentAcceptedInPast();
    this.updateInitialFormFieldsContent();
    this.getDynamicFormTemplate();
    this.validateForm();
    // leadsCollectorComponent will handle payment flow only if paymentFlowType is passed by parent component
    if (this.props.paymentFlowType) {
      this.handlePaymentFlow();
    }

    if (this.props.isEmbedded)
      this.props.setLeadCollectorSendButtonComponent(this.embeddedSendButton());
  };
  componentWillUnmount = () => {
    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.isDemo &&
      JSON.stringify(this.props.selectedWidgetAppType) !==
        JSON.stringify(prevProps.selectedWidgetAppType)
    ) {
      this.getDynamicFormTemplate();
    }
    if (
      utilsService.getIsClient() &&
      this.props.widgetContext.isPeerClientInfoUpdated !==
        prevProps.widgetContext.isPeerClientInfoUpdated &&
      this.props.widgetContext.isPeerClientInfoUpdated
    ) {
      this.updateInitialFormFieldsContent();
    }

    if (this.props.isEmbedded)
      if (
        prevState.isFormDataValid !== this.state.isFormDataValid ||
        this.props.isBookingFlowRunning !== prevProps.isBookingFlowRunning ||
        prevState.isFormFlowRunning !== this.state.isFormFlowRunning
      )
        this.props.setLeadCollectorSendButtonComponent(
          this.embeddedSendButton(),
        );
  };

  embeddedSendButton = () => {
    const sendBtnTxt =
      this.props.mentor.mentorDto.appControlDto.widgetEditableTexts?.[
        VIDABOO_CONSTANTS.EDITABLE_TEXTS.PRE_CHAT_FORM_CTA_BTN_TEXT
      ] || this.context.languageSet.INFO_COLLECTOR.SEND;
    return (
      <div className="et-embedded-button-wrapper">
        {this.sendButton(sendBtnTxt)}
      </div>
    );
  };

  sendButton = (btnTxt) => (
    <ButtonComponent
      type="primary"
      isDisabled={
        (!this.state.isFormDataValid &&
          this.state.dynamicFormTemplate?.type !==
            this.formTypes[
              VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING
            ]) ||
        (this.props.getRecipientsListWithAddButtonComp &&
          !this.props.areAllEmailsValid) //This bit is used in clickNTalk and anonymous page to allow form submission even if no emails are filled up in MeetingEmailsListComponent
      }
      showSpinner={
        this.state.isFormFlowRunning || this.props.isBookingFlowRunning
      }
      text={btnTxt}
      onClick={this.submitMessage}
    />
  );

  updateInitialFormFieldsContent = () => {
    let peerClientInfo = this.props.isDemo
      ? null
      : utilsService.getPeerClientInfo(
          this.props.mentor?.mentorDto?.mentorOwnerId,
          this.props.widgetContext.widgetDto,
        );
    let initialFormFieldsContent = {};
    if (peerClientInfo) {
      if (peerClientInfo.email) {
        initialFormFieldsContent.email = peerClientInfo.email;
      }
      if (peerClientInfo.phone_number) {
        initialFormFieldsContent.phone_number = peerClientInfo.phone_number;
      }
      if (peerClientInfo.name) {
        initialFormFieldsContent.name = peerClientInfo.name;
      }
      this.setState({initialFormFieldsContent});
    }
    if (this.props.requesterEmail?.length > 0) {
      initialFormFieldsContent.email = this.props.requesterEmail;
      this.setState({initialFormFieldsContent});
    }
    this.props.widgetContext.setIsPeerClientInfoUpdated(false);
  };

  handlePaymentFlow = () => {
    sessionTemplateService.getSessionTemplatesByMentorIdAndSessionType(
      this.props.mentor.mentorDto.mentorId,
      this.props.paymentFlowType,
      (sessionsData) => {
        const paymentFlowBasedSessionDtos = sessionsData?.filter((session) => {
          return session?.paymentFlow === this.props.paymentFlowType;
        });
        const paymentFlowBasedSessionDto =
          paymentFlowBasedSessionDtos?.length > 0 &&
          paymentFlowBasedSessionDtos[0]?.sessionCost > 0
            ? paymentFlowBasedSessionDtos[0]
            : null;
        this.setState({
          paymentFlowBasedSessionDto,
        });
      },
      (error) => {
        console.debug('Error: ', error);
        this.setState({
          paymentFlowBasedSessionDto: null,
        });
      },
    );
  };

  updateIsConsentAcceptedInPast = () => {
    const domainName = window.location.hostname;
    if (multiWidgetService.isConsentDomainNameExist(domainName)) {
      this.setState({isConsentAcceptedInPast: true, isConsentAccepted: true});
    }
  };

  getDynamicFormTemplate = async () => {
    if (this.props.mentor?.mentorDto?.mentorId) {
      this.setState({
        isFormLoading: true,
        formFields: [],
        consentFormField: null,
      });
      const response =
        await DynamicFormService?.getDynamicFormTemplateByMentorId(
          this.formTypes[this.props.selectedWidgetAppType],
          this.props.mentor?.mentorDto?.mentorId,
        );
      if (response.success) {
        this.doWhenFormTemplateReceived(response.data);
      } else {
        this.handleError(response);
      }
    }
  };

  doWhenFormTemplateReceived = (response) => {
    let consentFormField = null;
    const consentFormFieldIdx = response.formFields.findIndex(
      (formField) =>
        formField.questionType === VIDABOO_CONSTANTS.QUESTION_TYPE.CONSENT &&
        formField.isRequired,
    );
    const emailFormFieldIdx = response.formFields.findIndex(
      (formField) =>
        formField.questionType === VIDABOO_CONSTANTS.QUESTION_TYPE.EMAIL,
    );
    if (consentFormFieldIdx !== -1 && emailFormFieldIdx !== -1) {
      consentFormField = response.formFields[consentFormFieldIdx];
      response.formFields.splice(consentFormFieldIdx, 1); //remove consent field from form template
    }
    this.setState(
      {
        isFormLoading: false,
        dynamicFormTemplate: response,
        formFields: response.formFields,
        consentFormField,
      },
      () => {
        let messageToMentor = {...this.state.messageToMentor};
        messageToMentor.content = {};
        this.state.formFields.forEach((formField) => {
          messageToMentor.content = {
            ...messageToMentor.content,
            [formField.field_name]: {
              ...formField,
              answers:
                formField.field_name === 'email'
                  ? this.state.initialFormFieldsContent?.email
                  : formField.field_name === 'phone_number'
                    ? this.state.initialFormFieldsContent?.phone_number
                    : formField.field_name === 'name'
                      ? this.state.initialFormFieldsContent?.name
                      : null,
              isValidAnswer: true,
            },
          };
        });
        this.setState({messageToMentor});
      },
    );
  };

  sendMessageToMentor = () => {
    if (this.props.sendGA) {
      this.props.sendGA(
        VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.MESSAGE_TO_MENTOR,
      );
    }
    if (this.props.dispatchConsoltoEvents) {
      this.props.dispatchConsoltoEvents(
        VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.MESSAGE_TO_MENTOR,
      );
    }

    let clientEmail = null;
    let clientPhoneNumber = null;
    let clientName = null;
    Object.values(this.state.messageToMentor.content).forEach((val) => {
      if (val.field_name === 'email') {
        clientEmail = val.answers;
      } else if (val.field_name === 'phone_number') {
        clientPhoneNumber = val.answers;
      }
      if (val.field_name === 'name') {
        clientName = val.answers;
      }
    });
    // if (clientEmail && this.props.sendMailToMentor) {
    //   mailMessageObj.senderUserId = this.state.messageToMentor.senderUserId;
    //   mailMessageObj.recieverUserId = this.state.messageToMentor.receiverUserId;
    //   mailMessageObj.subject = this.state.messageToMentor.subject;
    //   mailMessageObj.email = clientEmail;
    //   mailMessageObj.content = this.getFormattedData(
    //     this.state.messageToMentor.content,
    //   );
    // }
    const peerInfo = {
      cFirstName: clientName,
      cEmail: clientEmail,
      cPhone: clientPhoneNumber,
      mentorOwnerId: this.props.mentor.mentorDto.mentorOwnerId,
      mentorId: this.props.mentor.mentorDto.mentorId,
    };
    utilsService.savePeerClientInfo(
      peerInfo,
      this.props.widgetContext.widgetDto,
    );
  };

  handleChange = (event, formField) => {
    let id = event.target.id;
    let messageToMentor = {...this.state.messageToMentor};
    let messageToMentorContent = messageToMentor.content;
    messageToMentorContent[event.target.id] = {
      ...formField,
      answers: event.target.value,
      isValidAnswer: true,
    };
    this.setState({messageToMentor});
    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }
    this.setState({
      typingTimeout: setTimeout(async () => {
        this.setState({messageToMentor}, () => {
          this.validateForm(this.state.messageToMentor.content[id]);
        });
      }, 1500),
    });
  };

  closeNotification = () => {
    this.initializeMessageToMentor();
    this.setState({
      showNotification: false,
      closeBtnFunc: null,
    });
  };

  initializeMessageToMentor = () => {
    const currentParentFullPath = PostMessageService.getLocation();
    const messageToMentor = {
      receiverUserId: this.props.mentor.mentorDto.mentorOwnerId,
      senderUserId: this.context.getCurrentUser().userId,
      chatRoomId: this.props?.widgetContext.chatRoomId,
      subject: 'Email from your potential client.',
      createdTime: Date.now(),
      submissionPageUrl:
        currentParentFullPath?.fullUrl ?? document.location.href,
      version: 'v2',
      content: {},
    };
    this.setState({messageToMentor});
  };

  submitMessage = async () => {
    //Firstly, dynamic form instance will be created,
    //If successfully created : Send message to mentor and email (if email field is present in form and sendMailToMentor bit is true)
    const emailValue = Object.values(this.state.messageToMentor.content).find(
      (formField) =>
        formField.questionType === VIDABOO_CONSTANTS.QUESTION_TYPE.EMAIL,
    )?.answers;
    const isEmailValid =
      VIDABOO_CONSTANTS.VALIDATION_PATTERNS.EMAIL.test(emailValue);
    if (this.props.isDemo || this.state.isFormFlowRunning) return;

    this.setState({isSubmitBtnClicked: true});
    if (this.validateForm()) {
      //if consent is enabled for form but user didn't accepted the consent -> show animation on consent
      if (
        !this.state.isConsentAcceptedInPast &&
        this.state.consentFormField &&
        !this.state.isConsentAccepted
      ) {
        if (!this.state.showConsentAnim) {
          this.setState({showConsentAnim: true});
        } else {
          this.setState({
            showNotification: true,
            notificationTxt: 'Please accept consent',
            closeBtnFunc: () => {
              this.setState({
                showNotification: false,
                notificationTxt: '',
                closeBtnFunc: null,
              });
            },
          });
        }
        return;
      } else if (
        !this.state.isConsentAcceptedInPast &&
        this.state.consentFormField &&
        this.state.isConsentAccepted
      ) {
        //if user has accepted the consent and but didn't provide the email -> ask for that
        if (!isEmailValid) {
          this.setState({
            showNotification: true,
            notificationTxt: 'Please provide the email',
            closeBtnFunc: () => {
              this.setState({
                showNotification: false,
                notificationTxt: '',
                closeBtnFunc: null,
              });
            },
          });
          return;
        }
      }
      this.onFinalFormSubmission();
    } else if (
      !isEmailValid &&
      this.state.dynamicFormTemplate?.type ===
        this.formTypes[VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING]
    ) {
      this.setState({
        showNotification: true,
        notificationTxt:
          'Without your email, we will not be able to send reminders and notifications.',
        closeBtnFunc: () => {
          this.setState({
            isFormDataValid: true,
            isSubmitBtnClicked: false,
            showNotification: false,
            notificationTxt: '',
            closeBtnFunc: null,
          });
        },
      });
    }
  };

  onFinalFormSubmission = async () => {
    this.setState({isFormFlowRunning: true});
    let formInstanceObj = {};
    formInstanceObj.mentorId = this.props.mentor.mentorDto.mentorId;
    formInstanceObj.senderUserId = this.context.getCurrentUser().userId;
    formInstanceObj.chatRoomId = this.props?.widgetContext.chatRoomId;

    formInstanceObj.dynamicFormTemplateId =
      this.state.dynamicFormTemplate.dynamicFormTemplateId;
    formInstanceObj.type = this.formTypes[this.props.selectedWidgetAppType];
    formInstanceObj.formFields = [];
    formInstanceObj.submissionPageUrl =
      this.state.messageToMentor.submissionPageUrl;
    let mentorFormFields = [];
    Object.values(this.state.messageToMentor.content).forEach(
      (formFieldVal) => {
        formInstanceObj.formFields.push({
          answers: formFieldVal.answers,
          field_name: formFieldVal.field_name,
        });
        mentorFormFields.push({
          title: formFieldVal.title,
          answers: formFieldVal.answers,
          questionType: formFieldVal.questionType,
          field_name: formFieldVal.field_name,
        });
      },
    );
    if (this.state.consentFormField && !this.state.isConsentAcceptedInPast) {
      //at this stage all the required validations for consent are already met
      formInstanceObj.formFields.push({
        answers: 'Accepted',
        field_name: 'consent',
      });
      mentorFormFields.push({
        title: 'Consent',
        answers: 'Accepted',
        questionType: VIDABOO_CONSTANTS.QUESTION_TYPE.CONSENT,
        field_name: 'consent',
      });
      //update consent domain names list in local storage
      const domainName = window.location.hostname;
      if (!multiWidgetService.isConsentDomainNameExist(domainName)) {
        multiWidgetService.setConsentDomainName(domainName);
      }
    }

    const response =
      await DynamicInstanceService.createDynamicFormInstance(formInstanceObj);
    if (response.success) {
      this.sendMessageToMentor();
      let messageToMentor = {...this.state.messageToMentor};
      messageToMentor.dynamicFormInstanceId =
        response.data.dynamicFormInstanceId;
      messageToMentor.dynamicFormTemplateId =
        response.data.dynamicFormTemplateId;
      messageToMentor.formType = this.state.dynamicFormTemplate.type;
      messageToMentor.content = mentorFormFields;
      this.props.callSendMessageFunc(
        'Inbox Message',
        VIDABOO_CONSTANTS.CHAT_SUBTYPES.INFO_MESSAGE,
        JSON.stringify(messageToMentor),
      );
      utilsService.updateNeedSendPeerInfo(
        false,
        this.props.mentor.mentorDto.mentorId,
      );

      if (
        this.props.selectedWidgetAppType ===
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING &&
        this.props.callbackSuccessInfoSend
      ) {
        this.props.callbackSuccessInfoSend({
          ...this.state.messageToMentor,
          mentorFormFields,
        });
      } else {
        if (this.state.paymentFlowBasedSessionDto) {
          this.setState({
            paymentDtoDFInstanceId: response.data.dynamicFormInstanceId,
            shouldStartPaymentFlow: true,
          });
        } else {
          this.setState({
            showNotification: true,
            notificationTxt: 'Your request was sent successfully',
            closeBtnFunc: null,
          });
        }
        if (this.props.callbackSuccessInfoSend) {
          this.props.callbackSuccessInfoSend({
            ...this.state.messageToMentor,
            formSubmittedMsg:
              this.props.mentor.mentorDto.appControlDto.widgetEditableTexts?.[
                VIDABOO_CONSTANTS.EDITABLE_TEXTS.PRE_CHAT_FORM_SUCCESS_MESSAGE
              ],
          });
        }
      }
    } else {
      console.debug('error', response);
    }
    this.setState({isFormFlowRunning: false});
  };

  validateForm = (formField, disableSubmitBtn) => {
    let messageToMentor = {...this.state.messageToMentor};
    let isFormValid = true;
    //Validate only particular field
    if (formField) {
      const isFieldValid =
        formField.isRequired && formField.answers.length === 0
          ? false
          : formField.questionType ===
                VIDABOO_CONSTANTS.QUESTION_TYPE.MULTI_LINE ||
              formField.questionType ===
                VIDABOO_CONSTANTS.QUESTION_TYPE.SINGLE_LINE
            ? true
            : this.formValidationRegexPatterns[formField.questionType].test(
                formField.answers,
              );
      messageToMentor.content[formField.field_name].isValidAnswer =
        isFieldValid;
      this.setState({messageToMentor});
      if (this.state.isSubmitBtnClicked) this.validateForm(null, true);
    } else {
      //Validate entire form content
      this.setState({isFormDataValid: true});
      const formContent = Object.values(messageToMentor.content ?? {});
      formContent.forEach((formField) => {
        if (
          (formField.isRequired && !formField?.answers) ||
          (formField.isRequired &&
            formField.answers &&
            formField.questionType !==
              VIDABOO_CONSTANTS.QUESTION_TYPE.MULTI_LINE &&
            formField.questionType !==
              VIDABOO_CONSTANTS.QUESTION_TYPE.SINGLE_LINE &&
            !this.formValidationRegexPatterns[formField.questionType].test(
              formField.answers,
            )) ||
          (formField.questionType !==
            VIDABOO_CONSTANTS.QUESTION_TYPE.MULTI_LINE &&
            formField.questionType !==
              VIDABOO_CONSTANTS.QUESTION_TYPE.SINGLE_LINE &&
            formField.answers &&
            !this.formValidationRegexPatterns[formField.questionType].test(
              formField.answers,
            ))
        ) {
          if (disableSubmitBtn) {
            this.setState({isFormDataValid: false});
          } else {
            isFormValid = false;
            messageToMentor.content[formField.field_name].isValidAnswer = false;
            this.setState({isFormDataValid: false, messageToMentor});
          }
        }
      });
      return isFormValid;
    }
  };

  getFormattedData = (formContent) => {
    let dataString = '';
    Object.values(formContent).forEach((val) => {
      if (val.title && val.answers)
        dataString = dataString + val.title + ' : ' + val.answers + ', ';
    });
    return dataString.slice(0, -2);
  };

  handleToolTip = (id) => {
    const showToolTip = {...this.state.showToolTip};
    showToolTip[id] = !showToolTip[id];
    this.setState({
      showToolTip,
    });
  };

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.submitMessage();
    }
  };

  handleError = (error) => {
    console.debug('error', error);
    this.setState({isFormLoading: false});
  };

  getFormField = (formField) => {
    const isEmailFieldDisabled =
      this.props.requesterEmail?.length > 0 &&
      this.formTypes[this.props.selectedWidgetAppType] ===
        VIDABOO_CONSTANTS.DYNAMIC_FORM_TEMPLATE_TYPE.PER_SCHEDULE &&
      formField.questionType === VIDABOO_CONSTANTS.QUESTION_TYPE.EMAIL;
    return (
      <>
        {formField.questionType ===
        VIDABOO_CONSTANTS.QUESTION_TYPE.PHONE_NUMBER ? (
          <div className="et-lead-ul-li et-lead-collector-textfield">
            <div className="et-lead-ul-wrap">
              {formField.isRequired && <div className="et-require-star"></div>}
              <PhoneInput
                id={formField.field_name}
                country={this.props.mentor.mentorDto.country}
                placeholder={formField.placeholder}
                value={
                  this.state.messageToMentor.content[formField.field_name]
                    ?.answers ?? ''
                }
                onChange={(phone) =>
                  this.handleChange(
                    {
                      target: {
                        value: phone,
                        id: formField.field_name,
                      },
                    },
                    formField,
                  )
                }
                onKeyDown={this.handleKeyDown}
                variant={'outlined'}
              />
            </div>
            {formField.tooltip && (
              <div
                className="et-lead-collector-tooltip"
                onMouseEnter={() => this.handleToolTip(formField.field_name)}
                onMouseLeave={() => this.handleToolTip(formField.field_name)}
                onClick={() => this.handleToolTip(formField.field_name)}>
                <i className="et-lead-collector-tooltip-icon far fa-question-circle" />
                {this.state.showToolTip[formField.field_name] && (
                  <ToolTipComponent
                    toolTipArrowStyle={{
                      borderLeftColor:
                        'var(--et-mentor-cta-btn-primary-background-color-fc)',
                    }}
                    toolTipLabelStyle={{
                      background:
                        'var(--et-mentor-cta-btn-primary-background-color)',
                    }}
                    toolTipTxt={formField.tooltip}
                    toolTipPosition="left"
                  />
                )}
              </div>
            )}
            {!this.state.messageToMentor.content[formField.field_name]
              ?.isValidAnswer && (
              <div className="et-lc-input-error">{'Invalid input'}</div>
            )}
          </div>
        ) : formField.questionType ===
          VIDABOO_CONSTANTS.QUESTION_TYPE.MULTI_LINE ? (
          <div className="et-lead-ul-li et-lead-collector-textarea">
            <div className="et-lead-ul-wrap">
              {formField.isRequired && <div className="et-require-star"></div>}
              <textarea
                id={formField.field_name}
                className="et-lead-collector-textfield-textarea"
                spellCheck={true}
                placeholder={formField.placeholder}
                value={
                  this.state.messageToMentor.content[formField.field_name]
                    ?.answers ?? ''
                }
                onChange={(e) => this.handleChange(e, formField)}
                // onKeyDown={this.handleKeyDown} // on text-area we don't want to submit upon enter.
              />
            </div>
            {formField.tooltip && (
              <div
                className="et-lead-collector-tooltip"
                onMouseEnter={() => this.handleToolTip(formField.field_name)}
                onMouseLeave={() => this.handleToolTip(formField.field_name)}
                onClick={() => this.handleToolTip(formField.field_name)}>
                <i className="et-lead-collector-tooltip-icon far fa-question-circle" />
                {this.state.showToolTip[formField.field_name] && (
                  <ToolTipComponent
                    toolTipArrowStyle={{
                      borderLeftColor:
                        'var(--et-mentor-cta-btn-primary-background-color-fc)',
                    }}
                    toolTipLabelStyle={{
                      background:
                        'var(--et-mentor-cta-btn-primary-background-color)',
                    }}
                    toolTipTxt={formField.tooltip}
                    toolTipPosition="left"
                  />
                )}
              </div>
            )}
            {!this.state.messageToMentor.content[formField.field_name]
              ?.isValidAnswer && (
              <div className="et-lc-input-error">{'Invalid input'}</div>
            )}
          </div>
        ) : (
          formField.questionType !==
            VIDABOO_CONSTANTS.QUESTION_TYPE.CONSENT && (
            <div className="et-lead-ul-li et-lead-collector-textfield">
              <div
                className={`et-lead-ul-wrap ${
                  isEmailFieldDisabled
                    ? 'et-lead-collector-textfield-input-disabled'
                    : ''
                }`}>
                {formField.isRequired && (
                  <div className="et-require-star"></div>
                )}
                <InputComponent
                  id={formField.field_name}
                  className="et-lead-collector-textfield-input"
                  disabled={isEmailFieldDisabled}
                  type={
                    formField.questionType ===
                    VIDABOO_CONSTANTS.QUESTION_TYPE.NUMBER
                      ? 'number'
                      : 'text'
                  }
                  placeholder={formField.placeholder}
                  value={
                    this.state.messageToMentor.content[formField.field_name]
                      ?.answers ?? ''
                  }
                  onChange={(e) => this.handleChange(e, formField)}
                  onKeyDown={this.handleKeyDown}
                />
              </div>
              {formField.tooltip && (
                <div
                  className="et-lead-collector-tooltip"
                  onMouseEnter={() => this.handleToolTip(formField.field_name)}
                  onMouseLeave={() => this.handleToolTip(formField.field_name)}
                  onClick={() => this.handleToolTip(formField.field_name)}>
                  <i className="et-lead-collector-tooltip-icon far fa-question-circle" />
                  {this.state.showToolTip[formField.field_name] && (
                    <ToolTipComponent
                      toolTipArrowStyle={{
                        borderLeftColor:
                          'var(--et-mentor-cta-btn-primary-background-color-fc)',
                      }}
                      toolTipLabelStyle={{
                        background:
                          'var(--et-mentor-cta-btn-primary-background-color)',
                      }}
                      toolTipTxt={formField.tooltip}
                      toolTipPosition="left"
                    />
                  )}
                </div>
              )}
              {!this.state.messageToMentor.content[formField.field_name]
                ?.isValidAnswer && (
                <div className="et-lc-input-error">{'Invalid input'}</div>
              )}
              {formField.questionType ===
                VIDABOO_CONSTANTS.QUESTION_TYPE.EMAIL &&
                this.props.getRecipientsListWithAddButtonComp &&
                this.props.getRecipientsListWithAddButtonComp()}
            </div>
          )
        )}
      </>
    );
  };

  doWhenPaymentFlowCompletedSuccessfully = (response) => {
    const status = response.status;
    if (status === VIDABOO_CONSTANTS.C2C_CUSTOMER_PAYMENT_SUCCESSFUL_STATUS) {
      this.handleToast(VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS);
      this.setState({
        shouldStartPaymentFlow: false,
        paymentDtoDFInstanceId: null,
      });
      this.closeNotification();
    } else {
      this.handleToast(VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE);
    }
  };

  closePaymentFlow = () => {
    this.setState({
      shouldStartPaymentFlow: false,
      paymentDtoDFInstanceId: null,
    });
  };

  doWhenPaymentFailed = () => {
    this.handleToast(VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE);
  };

  rejectPayment = () => {
    this.handleToast(
      VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS,
      'Payment cancelled',
    );
    this.closePaymentFlow();
  };

  handleToast = (toastType, toastTitle) => {
    const tempToastText = toastTitle
      ? toastTitle
      : toastType === VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS
        ? 'Payment success'
        : 'Payment failed';
    const toastObj = utilsService.getToastObj({
      toastTitle: tempToastText,
      toastType,
    });
    this.context.addToastObj(toastObj);
  };

  onConsentChange = () => {
    this.setState({isConsentAccepted: !this.state.isConsentAccepted});
  };

  onConsentReadMoreClicked = () => {
    this.setState({showConsentAnim: false});
  };

  render() {
    const {isPersonalPage} = this.props;

    let formTitleText = null;
    if (this.props.mentor.mentorDto.appControlDto.widgetEditableTexts) {
      if (
        this.formTypes[this.props.selectedWidgetAppType] ===
        VIDABOO_CONSTANTS.DYNAMIC_FORM_TEMPLATE_TYPE.CONTACT_FORM
      ) {
        formTitleText =
          this.props.mentor.mentorDto.appControlDto.widgetEditableTexts[
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.INFO_COLLECTOR
          ] || 'Send a message and I will get right back to you';
      } else if (
        this.props.mentor.mentorDto.appControlDto.widgetEditableTexts[
          VIDABOO_CONSTANTS.EDITABLE_TEXTS[
            this.formTypes[this.props.selectedWidgetAppType] + '_FORM_TITLE'
          ]
        ]
      ) {
        formTitleText =
          this.props.mentor.mentorDto.appControlDto.widgetEditableTexts[
            VIDABOO_CONSTANTS.EDITABLE_TEXTS[
              this.formTypes[this.props.selectedWidgetAppType] + '_FORM_TITLE'
            ]
          ];
      }
    }

    if (
      this.props.selectedWidgetAppType ===
        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING &&
      (!formTitleText || formTitleText?.length === 0)
    ) {
      formTitleText =
        this.context.languageSet.CONSOLTO_WIDGET.IN_ORDER_TO_GET_BACK_TO_YOU;
    }

    let btnTxt;
    if (this.state.isFormFlowRunning || this.props.isBookingFlowRunning) {
      btnTxt = null;
    } else {
      const widgetEditableTexts =
        this.props.mentor.mentorDto.appControlDto?.widgetEditableTexts;
      const paymentFlowBasedSessionDto =
        this.props.selectedWidgetAppType ===
        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING
          ? this.props.paymentFlowBasedSessionDto
          : this.state.paymentFlowBasedSessionDto;
      const languageSet = this.context.languageSet;

      if (
        this.props.selectedWidgetAppType ===
        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING
      ) {
        btnTxt =
          widgetEditableTexts?.SCHEDULE_MEETING_CTA_BTN_TEXT ||
          (paymentFlowBasedSessionDto
            ? `Submit and pay ${paymentFlowBasedSessionDto.sessionCost} ${paymentFlowBasedSessionDto.sessionCurrency}`
            : this.props.submitBtnTxt ||
              widgetEditableTexts?.INFO_COLLECTOR_CTA_BTN_TEXT ||
              languageSet.INFO_COLLECTOR.SEND);
      } else {
        btnTxt =
          widgetEditableTexts?.INFO_COLLECTOR_CTA_BTN_TEXT ||
          (paymentFlowBasedSessionDto
            ? `Submit and pay ${paymentFlowBasedSessionDto.sessionCost} ${paymentFlowBasedSessionDto.sessionCurrency}`
            : languageSet.INFO_COLLECTOR.SEND);
      }
    }

    if (!formTitleText && this.props.isEmbedded) {
      formTitleText =
        this.context.languageSet.CONSOLTO_WIDGET.IN_ORDER_TO_GET_BACK_TO_YOU;
    }

    return this.state.isFormLoading ? (
      <ShimmerWithEmptyImageComponent
        shimmerComponentType={
          VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.LEADS_FORM
        }
      />
    ) : (
      <div
        className={
          this.props.isEmbedded
            ? 'et-lead-collector-component-wrap'
            : isPersonalPage
              ? 'et-personal-page-right-content-wrap et-pp-right-content-wrap-no-border'
              : 'et-widget-body-content-wrap'
        }>
        <div
          className={`et-lead-collector-container ${
            utilsService.getIsInWidget() || this.props.isDemo
              ? 'et-widget-lead-collector-container'
              : ''
          } ${isPersonalPage ? 'et-pp-lead-collector-container' : ''} ${utilsService.isMobileDevice() ? 'et-lead-collector-container-mobile-viewport' : ''}`}>
          <div
            className={`et-lead-collector-component ${!this.state.isFormDataValid ? 'et-lcc-shake-form' : ''}`}>
            <div
              className={
                this.props.isEmbedded
                  ? 'et-lead-collector-ul-embedded'
                  : 'et-lead-collector-ul'
              }>
              {formTitleText && (
                <div className="et-lead-ul-li et-lead-collector-title-text">
                  <WidgetTitleComponent title={formTitleText} />
                </div>
              )}
              <div className="et-lead-collector-form-fields-wrap">
                {this.state.formFields.map((formField, index) => {
                  return (
                    <React.Fragment key={index}>
                      {this.getFormField(formField)}
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
            {(!this.state.isConsentAcceptedInPast || this.props.isDemo) &&
              this.state.consentFormField && (
                <div
                  className={`et-lc-consent-wrap ${
                    this.state.showConsentAnim
                      ? 'et-lc-consent-wrap-with-anim'
                      : ''
                  } ${this.state.showConsentAnim ? 'et-lcc-shake-form' : ''}`}>
                  <ConsentComponent
                    isChecked={this.state.isConsentAccepted}
                    consentTxt={this.state.consentFormField.placeholder}
                    title={this.state.consentFormField.title}
                    onConsentChange={this.onConsentChange}
                    onConsentReadMoreClicked={this.onConsentReadMoreClicked}
                  />
                </div>
              )}
            <div
              className={`et-lead-collector-footer-btns-wrap ${isPersonalPage ? 'et-lc-pp-form-btn' : 'et-v2-widget-btn-wrap'} ${this.props.isPersonalSchedulePage ? 'et-lc-pp-scheduling-btns-wrap' : ''} `}>
              {this.props.backBtnFunc && (
                <div
                  className={
                    this.props.isPersonalSchedulePage
                      ? 'et-lc-pp-back-btn'
                      : 'et-lc-w-back-btn'
                  }>
                  <ButtonComponent
                    type="primary-outlined"
                    isDisabled={false}
                    onClick={this.props.backBtnFunc}
                    text={this.props.backBtnTxt ? this.props.backBtnTxt : null}
                    image={
                      !this.props.backBtnTxt ? (
                        <ArrowIcon fillColor="var(--et-mentor-cta-btn-primary-background-color-fc)" />
                      ) : null
                    }
                  />
                </div>
              )}

              {!this.props.isEmbedded && this.sendButton(btnTxt)}
            </div>
          </div>
          {this.state.showNotification && (
            <NotificationComponent
              notificationTxt={this.state.notificationTxt}
              closeBtnTxt="Close"
              closeBtnFunc={this.state.closeBtnFunc ?? this.closeNotification}
            />
          )}
          {this.state.shouldStartPaymentFlow &&
            this.state.paymentFlowBasedSessionDto && (
              <div className="et-lc-payment-component">
                <Suspense fallback={<SuspenseLoader />}>
                  <C2cPaymentComponent
                    shouldStartPaymentFlow={this.state.shouldStartPaymentFlow}
                    currentUser={this.context.getCurrentUser()}
                    dynamicFormInstanceId={this.state.paymentDtoDFInstanceId}
                    mentorDto={this.props.mentor.mentorDto}
                    sessionTemplateDto={this.state.paymentFlowBasedSessionDto}
                    chatRoomId={this.props?.widgetContext.chatRoomId}
                    paymentFlowType={this.props.paymentFlowType}
                    closePaymentFlow={this.closePaymentFlow}
                    doWhenPaymentFailed={this.doWhenPaymentFailed}
                    doWhenPaymentFlowCompletedSuccessfully={
                      this.doWhenPaymentFlowCompletedSuccessfully
                    }
                    rejectPayment={this.rejectPayment}
                  />
                </Suspense>
              </div>
            )}
        </div>
      </div>
    );
  }
}

LeadCollectorComponent.contextType = AppContext;
export default withWidgetContext(LeadCollectorComponent);
